import { apolloClient } from '@/apollo/client'

import { CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_CREATE_MUTATION } from '@/graphql/consultantNotificationEmailAddress/consultantNotificationEmailAddressCreate'
import { CONSULTANT_NOTIFICATION_EMAIL_ADDRESSES_UPDATE_MUTATION } from '@/graphql/consultantNotificationEmailAddress/consultantNotificationEmailAddressesUpdate'
import { CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_UPDATE_MUTATION } from '@/graphql/consultantNotificationEmailAddress/consultantNotificationEmailAddressUpdate'
import { CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_DELETE_MUTATION } from '@/graphql/consultantNotificationEmailAddress/consultantNotificationEmailAddressDelete'

export const ConsultantNotificationEmailAddressService = {
    create (variables) {
        return apolloClient.mutate({
            mutation: CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_CREATE_MUTATION,
            variables,
        }).then(response => response.data.consultantNotificationEmailAddressCreate)
    },
    update (consultantNotificationEmailAddressVariables) {
        return apolloClient.mutate({
            mutation: CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_UPDATE_MUTATION,
            variables: {
                consultantNotificationEmailAddress: consultantNotificationEmailAddressVariables,
            },
        }).then(response => response.data.consultantNotificationEmailAddressUpdate)
    },
    bulkUpdate (consultantNotificationEmailAddressesVariables) {
        return apolloClient.mutate({
            mutation: CONSULTANT_NOTIFICATION_EMAIL_ADDRESSES_UPDATE_MUTATION,
            variables: {
                consultantNotificationEmailAddresses: consultantNotificationEmailAddressesVariables,
            },
        }).then(response => response.data.consultantNotificationEmailAddressesUpdate)
    },
    delete (id, forceDelete) {
        return apolloClient.mutate({
            mutation: CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_DELETE_MUTATION,
            variables: {
                id,
                forceDelete,
            },
        }).then(response => response.data.consultantNotificationEmailAddressDelete)
    },
}
